/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    SimilarRequestObjection,
    SimilarRequestObjectionFromJSON,
    SimilarRequestObjectionFromJSONTyped,
    SimilarRequestObjectionToJSON,
    SimilarRequestSource,
    SimilarRequestSourceFromJSON,
    SimilarRequestSourceFromJSONTyped,
    SimilarRequestSourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface VaultSearchResult
 */
export interface VaultSearchResult {
    /**
     * 
     * @type {string}
     * @memberof VaultSearchResult
     */
    similarRequestId?: string;
    /**
     * 
     * @type {string}
     * @memberof VaultSearchResult
     */
    text?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VaultSearchResult
     */
    response?: string | null;
    /**
     * 
     * @type {number}
     * @memberof VaultSearchResult
     */
    score?: number | null;
    /**
     * 
     * @type {Array<SimilarRequestObjection>}
     * @memberof VaultSearchResult
     */
    objections?: Array<SimilarRequestObjection> | null;
    /**
     * 
     * @type {SimilarRequestSource}
     * @memberof VaultSearchResult
     */
    source?: SimilarRequestSource;
    /**
     * 
     * @type {Array<string>}
     * @memberof VaultSearchResult
     */
    matchedFields?: Array<string> | null;
}

export function VaultSearchResultFromJSON(json: any): VaultSearchResult {
    return VaultSearchResultFromJSONTyped(json, false);
}

export function VaultSearchResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): VaultSearchResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'similarRequestId': !exists(json, 'similarRequestId') ? undefined : json['similarRequestId'],
        'text': !exists(json, 'text') ? undefined : json['text'],
        'response': !exists(json, 'response') ? undefined : json['response'],
        'score': !exists(json, 'score') ? undefined : json['score'],
        'objections': !exists(json, 'objections') ? undefined : (json['objections'] === null ? null : (json['objections'] as Array<any>).map(SimilarRequestObjectionFromJSON)),
        'source': !exists(json, 'source') ? undefined : SimilarRequestSourceFromJSON(json['source']),
        'matchedFields': !exists(json, 'matchedFields') ? undefined : json['matchedFields'],
    };
}

export function VaultSearchResultToJSON(value?: VaultSearchResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'similarRequestId': value.similarRequestId,
        'text': value.text,
        'response': value.response,
        'score': value.score,
        'objections': value.objections === undefined ? undefined : (value.objections === null ? null : (value.objections as Array<any>).map(SimilarRequestObjectionToJSON)),
        'source': SimilarRequestSourceToJSON(value.source),
        'matchedFields': value.matchedFields,
    };
}


